import kotlinx.coroutines.flow.MutableStateFlow

/**
 * Whether ads should be hidden because the current lobby's host holds Banko Plus. The ad banner
 * lives in the root Scaffold (App.kt) and has no game in scope, so the game screen publishes the
 * current lobby's [models.DomainGame.hostPerksActive] here for the banner to observe.
 *
 * Owned by the most recently opened game screen: BankoGameScreenUseCase claims it on open,
 * publishes as it observes the game, and releases it when the screen goes away. An older screen
 * cleaned up after a newer one opened (a quick leave-then-join) can no longer overwrite it. All
 * callers run on the main thread.
 */
object LobbyAdState {
    val adsDisabledForLobby = MutableStateFlow(false)
    private var owner: Any? = null

    /** A game screen opening takes over the flag, with ads back on until its host is known. */
    fun claim(owner: Any) {
        this.owner = owner
        adsDisabledForLobby.value = false
    }

    /** Publishes [disabled] while [owner] is still the latest game screen. */
    fun publish(owner: Any, disabled: Boolean) {
        if (this.owner === owner) adsDisabledForLobby.value = disabled
    }

    /** The game screen went away: ads come back, unless a newer screen has already taken over. */
    fun release(owner: Any) {
        if (this.owner !== owner) return
        this.owner = null
        adsDisabledForLobby.value = false
    }
}
